import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    ThisDoctorIsOutOfNetwork: {
        id: 'Booking.Pages.AppointmentInfo.ThisDoctorIsOutOfNetwork',
        defaultMessage: 'This doctor is out-of-network',
    },
    OutOfNetworkModalDescription: {
        id: 'Booking.Pages.AppointmentInfo.OutOfNetworkModalDescription',
        defaultMessage: '{provider} is out-of-network for the insurance you selected, {insuranceName}. '
        + 'You may have a higher copay or be responsible for the full cost of your doctor visit.',
    },
    BookAnyway: {
        id: 'Booking.Pages.AppointmentInfo.BookAnyway',
        defaultMessage: 'Book Anyway',
    },
    ChangeInsurance: {
        id: 'Booking.Pages.AppointmentInfo.ChangeInsurance',
        defaultMessage: 'Change Insurance',
    },
});

export const ActionTypes = {
    CLICK_BOOK_ANYWAY: 'actions/modals/insurancemodal/CLICK_BOOK_ANYWAY',
    CLICK_CHANGE_INSURANCE: 'actions/modals/insurancemodal/CLICK_CHANGE_INSURANCE',
    SHOW_OUT_OF_NETWORK_MODAL: 'actions/modals/insurancemodal/SHOWS',
};
